import React from "react";
import { Layout, styles } from "../../layout";
import CustomLink from "../components/hoverlink";

const Projects: React.FC = () => {
  const projectLinks = [
    {
      section: "Projects",
      links: [
        {
          title: "Workout Tracker",
          path: "/landing",
          description:
            "My first firebase project that I built to track my workouts. You can log all your lifts with your google account to see progress over time.",
        },
        {
          title: "IRA Stocks",
          path: "/stocks/ira",
          description:
            "Part of my Independent Study in my final semester of Pitt. I ranked public equities and explored retirement and compounding.",
        },
        {
          title: "Top News",
          path: "/topnews",
          description: "Remade bloomberg top news.",
        },
        {
          title: "Spend Tracker",
          path: "/cura",
          description:
            "My first firebase project that I built to track my workouts. You can log all your lifts with your google account to see progress over time.",
        },
        {
          title: "How Much Have I Made?",
          path: "/howmuchhaveimade",
          description:
            "A calculator to see how much you made since you bought a stock.",
        },

        {
          title: "Book Club",
          path: "/bookclub",
          description:
            "A living library of books I'm reading with reflections and key takeaways.",
        },
        {
          title: "Carbon Calc",
          path: "/carboncalc",
          description:
            "Built a web-based carbon calculator that stores results to a Google Sheet.",
        },

        {
          title: "Resume Line AI",
          path: "/resumeai",
          description:
            "Use a custom chat GPT AI prompt to help improve resume lines. Just wanted to add some AI to my site lol. ",
        },
        {
          title: "75 Hard",
          path: "/75hard",
          description:
            "Tracked daily goals, sent automated emails, and displayed progress on site.",
        },
        {
          title: "Wakeup Log",
          path: "/daylogger",
          description:
            "Logged wake-up times to a spreadsheet using a single-click form.",
        },
        {
          title: "Habit Tracker",
          path: "/habittracker",
          description:
            "Logged wake-up times to a spreadsheet using a single-click form.",
        },
        {
          title: "Food Budget Tracker",
          path: "/foodlanding",
          description:
            "My firebase project to track my food expenses. You can log all your grocery receipts just by taking a picture! Login with your google account to see progress over time. (Doesn't work yet)",
        },
        {
          title: "Countries Traveled",
          path: "/countries-traveled.html",
          description:
            "A world map of countries I've visited, with trip dates and places.",
        },
      ],
    },
  ];

  return (
    <Layout title="Projects">
      <p style={styles.paragraph}>
        Here is the list of projects I have built on this site. I am working to
        develop my skills and make useful enhancements to my life.
      </p>

      <h2 style={styles.subHeader}>Project Links</h2>
      <div style={{ display: "flex", gap: "80px", flexWrap: "wrap" }}>
        {projectLinks.map((section, index) => (
          <div key={index} style={{ minWidth: "200px" }}>
            <h3 style={styles.sectionTitle}>{section.section}</h3>
            <ul style={{ listStyle: "none", padding: 0 }}>
              {section.links.map((link, linkIndex) => (
                <li key={linkIndex} style={{ marginBottom: "20px" }}>
                  <CustomLink href={link.path}>{link.title}</CustomLink>

                  <p>{link.description}</p>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </Layout>
  );
};

export default Projects;
